var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineContactSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39443 20.9794V17.9049C5.11565 17.6828 1.70801 14.13 1.70801 9.79997C1.70801 5.32476 5.34625 1.68652 9.82145 1.68652C14.2967 1.68652 17.9349 5.32476 17.9349 9.79997C17.9349 14.0275 14.997 18.2806 10.6157 20.3901L9.39443 20.9794ZM9.82145 3.39462C6.2857 3.39462 3.4161 6.26421 3.4161 9.79997C3.4161 13.3357 6.2857 16.2053 9.82145 16.2053H11.1025V18.1696C14.2113 16.2053 16.2268 12.977 16.2268 9.79997C16.2268 6.26421 13.3572 3.39462 9.82145 3.39462ZM8.9674 13.2162H10.6755V14.9242H8.9674V13.2162ZM10.6755 11.9351H8.9674C8.9674 9.15943 11.5295 9.37294 11.5295 7.66485C11.5295 6.7254 10.7609 5.95676 9.82145 5.95676C8.882 5.95676 8.11336 6.7254 8.11336 7.66485H6.40526C6.40526 5.77741 7.93401 4.24866 9.82145 4.24866C11.7089 4.24866 13.2376 5.77741 13.2376 7.66485C13.2376 9.79997 10.6755 10.0135 10.6755 11.9351Z",
    fill: "#1D2951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineContactSupport);
export default __webpack_public_path__ + "static/media/ic_outline-contact-support.ead4de7dbcc41c188022d741a67cc193.svg";
export { ForwardRef as ReactComponent };